var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-border-box-10',{attrs:{"reverse":true}},[_c('div',{staticClass:"map-wrapper"},[_c('div',{staticClass:"base-map",attrs:{"id":_vm.mapId}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }